import React, { useState } from 'react';
import { X, Zap, AlertCircle } from 'lucide-react';
import { useLots } from '../../../../contexts/LotsContext';

const ReconcileModal = ({ lot, onClose }) => {
  const [initialQuantity, setInitialQuantity] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const { reconcileLightningLot } = useLots();
  
  // Imprimir datos para depuración
  console.log('Datos de lote recibidos en modal:', {
    lotId: lot.id,
    remaining_quantity: lot.remaining_quantity,
    quantity: lot.quantity,
    initialQuantity: lot.initial_quantity,
    status: lot.status,
    loteCompleto: lot
  });
  
  // En un lote relámpago, la cantidad vendida es el valor absoluto de la cantidad disponible
  // que es un valor negativo, en lotes, puede estar en remaining_quantity o en quantity
  const soldQuantity = Math.abs(Number(lot.remaining_quantity || lot.quantity || 0));
  
  // La cantidad restante estimada es initial_quantity (entrada del usuario) + remaining_quantity (que es negativo)
  const remainingQty = Number(lot.remaining_quantity || lot.quantity || 0);
  const estimatedRemaining = initialQuantity ? 
    Number(initialQuantity) + remainingQty : null;
  
  const handleSubmit = async () => {
    if (!initialQuantity || isNaN(Number(initialQuantity))) {
      setError('Por favor ingresa una cantidad válida');
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    
    try {
      await reconcileLightningLot(lot.id, Number(initialQuantity));
      onClose();
    } catch (err) {
      setError(err.message || 'Error al reconciliar el lote');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      />
      <div className="fixed inset-x-0 bottom-0 bg-white dark:bg-gray-800 rounded-t-xl p-5 z-50 shadow-xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center">
            <Zap className="w-6 h-6 text-amber-500 dark:text-amber-400 mr-2" />
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Reconciliar Lote Relámpago</h2>
          </div>
          <button 
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
          </button>
        </div>
        
        {error && (
          <div className="mb-4 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md text-red-600 dark:text-red-400 text-sm">
            <AlertCircle className="w-4 h-4 inline-block mr-1" />
            {error}
          </div>
        )}
        
        <p className="mb-4 text-gray-600 dark:text-gray-300 text-sm">
          Este lote se creó automáticamente durante una venta. Para reconciliarlo, 
          ingresa la cantidad inicial real que tenías de este producto.
        </p>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Cantidad inicial real
          </label>
          <input
            type="number"
            value={initialQuantity}
            onChange={(e) => setInitialQuantity(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 dark:bg-gray-700 dark:text-white"
            placeholder={`Cantidad en ${lot.unit_sign || 'unidades'}`}
          />
        </div>
        
        <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-md mb-4">
          <div className="flex justify-between mb-2">
            <span className="text-gray-600 dark:text-gray-300">Cantidad vendida:</span>
            <span className="font-medium dark:text-white">{soldQuantity} {lot.unit_sign || ''}</span>
          </div>
          
          <div className="flex justify-between">
            <span className="text-gray-600 dark:text-gray-300">Cantidad restante estimada:</span>
            <span className="font-medium dark:text-white">
              {estimatedRemaining !== null ? `${estimatedRemaining} ${lot.unit_sign || ''}` : '-'}
            </span>
          </div>
          
          {estimatedRemaining !== null && estimatedRemaining < 0 && (
            <div className="mt-2 text-amber-600 dark:text-amber-400 text-sm flex items-center">
              <AlertCircle className="w-4 h-4 mr-1" />
              La cantidad restante sería negativa. Considera aumentar la cantidad inicial.
            </div>
          )}
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700"
            disabled={isSubmitting}
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-amber-500 dark:bg-amber-600 text-white rounded-md hover:bg-amber-600 dark:hover:bg-amber-700"
            disabled={!initialQuantity || isSubmitting}
          >
            {isSubmitting ? 'Procesando...' : 'Confirmar Reconciliación'}
          </button>
        </div>
      </div>
    </>
  );
};

export default ReconcileModal; 